module.exports = __webpack_public_path__ + "img/banner-1-m.361e7c8f.jpg";